import React from "react";
import "./Examinations.css";
import PaginationTable from "../../components/paginationTable/PaginationTable";
import {
  Comparator,
  dateFilter,
  selectFilter,
  textFilter,
} from "react-bootstrap-table2-filter";
import CamplaCoreService from "../../services/CamplaCoreService";
import CreateExaminationDialog from "./dialogs/createExaminationDialog/CreateExaminationDialog";
import Button from "react-bootstrap/Button";
import UnsavedChangesDialog from "../../components/dialogs/unsavedChangesDialog/UnsavedChangesDialog";
import ExaminationActionCell from "./examinationActionCell/ExaminationActionCell";
import ExaminationStatusCell from "./examinationStatusCell/ExaminationStatusCell";
import ExaminationStatus from "../../helpers/ExaminationStatus";
import {
  Col,
  Container,
  Row
} from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlay,
  faPlus,
  faSyncAlt,
} from "@fortawesome/free-solid-svg-icons";
import StorageService from "../../services/StorageService";
import APIErrorHelper from "../../helpers/APIErrorHelper";
import { Link, withRouter } from "react-router-dom";
import ConfirmationDialog from "../../components/dialogs/confirmationDialog/ConfirmationDialog";
import ValidationHelper from "../../helpers/ValidationHelper";
import DateTimeHelper from "../../helpers/DateTimeHelper";
import { faUsers } from "@fortawesome/fontawesome-free-solid";
import OpenExamAndAcceptSubmissionsDialog from "../singleExamination/dialogs/openExamAndAcceptSubmissionsDialog/OpenExamAndAcceptSubmissionsDialog";
import PaginationTableFilterToggle from "../../components/paginationTableFilterToggle/PaginationTableFilterToggle";

class Examinations extends React.Component {
  tableId = "examinationsTable";

  constructor(props) {
    super(props);
    let showFilters = StorageService.tableConfigShowFilters(this.tableId);
    this.state = {
      examinations: [],
      moduleClasses: [],
      instanceTemplates: [],
      networkProfiles: [],
      users: [],
      moduleClassesMap: new Map(),
      instanceTemplatesMap: new Map(),
      networkProfilesMap: new Map(),
      selectedInstanceTemplate: null,
      selectedCloneExamination: null,
      showCreateExaminationModal: false,
      showUnsavedChangesDialog: false,
      closeAction: () => {},
      examinationToDeleteOrEdit: null,
      columns: [],
      openExam: false,
      studentFileProposals: [],
      showConfirmationDialog: false,
      confirmationDialogTitle: "",
      confirmationDialogBody: "",
      onConfirmationDialogSubmit: () => {},
      confirmationDialogRightButtonVariant: "primary",
      confirmationDialogLeftButtonVariant: "secondary",
      displayFilter: showFilters ? "initial" : "none",
      showFilters,
      apiError: "",
      dialogApiError: "",
    };

    this.fetchData = this.fetchData.bind(this);
    this.registerEventListener = this.registerEventListener.bind(this);
    this.setActionConfirmationState = this.setActionConfirmationState.bind(
      this,
    );
    this.setActionConfirmationStateOpenExam = this.setActionConfirmationStateOpenExam.bind(
      this,
    );
    this.handleCreateExamination = this.handleCreateExamination.bind(this);
    this.handleCreateMultipleExaminations = this.handleCreateMultipleExaminations.bind(
      this,
    );
    this.handleUpdateEvent = this.handleUpdateEvent.bind(this);
    this.handleRemoveEvent = this.handleRemoveEvent.bind(this);
    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handlePause = this.handlePause.bind(this);
    this.handleResume = this.handleResume.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleRetry = this.handleRetry.bind(this);
    this.handleClone = this.handleClone.bind(this);
    this.onHideCreateDialog = this.onHideCreateDialog.bind(this);
    this.resolveInstanceTemplate = this.resolveInstanceTemplate.bind(this);
  }

  resolveInstanceTemplate(instanceTemplateId) {
    if (!ValidationHelper.isID(instanceTemplateId)) return;
    const instanceTemplate = this.state.instanceTemplates.find(
      (it) => it._id === instanceTemplateId,
    );
    if (instanceTemplateId)
      this.setState({ selectedInstanceTemplate: instanceTemplate });
  }

  handleUpdateEvent(event) {
    let newExamination = {};
    for (const el of this.state.examinations) {
      if (el._id === event.object._id) {
        newExamination = el;
      } else {
        console.log("No corresponding examination");
      }
    }

    newExamination["status"] = event.object.status;

    const examinations = this.state.examinations.map((exam) =>
      exam._id === newExamination._id ? newExamination : exam,
    );

    StorageService.set("extendedExaminations", examinations);
    this.setState({ examinations });
  }

  handleRemoveEvent(event) {
    const filteredExaminations = this.state.examinations.filter(
      (e) => e._id !== event.object._id,
    );
    StorageService.set("extendedExaminations", filteredExaminations);
    this.setState({
      examinations: filteredExaminations,
    });
  }

  registerEventListener() {
    CamplaCoreService.addEventListener("Examinations", (event) => {
      if (
        event.model === "examinations" &&
        this.state.examinations.some((exam) => exam._id === event.object._id)
      ) {
        switch (event.action) {
          case "update":
            CamplaCoreService.addWorkerQueueTask(() =>
              this.handleUpdateEvent(event),
            );
            break;

          case "remove":
            CamplaCoreService.addWorkerQueueTask(() =>
              this.handleRemoveEvent(event),
            );
            break;
          default:
            break;
        }
      }
    });
  }

  async componentDidMount() {
    this.paginationTableRef = React.createRef();

    const examinations = StorageService.getReferenceType(
      "extendedExaminations",
    );
    const moduleClasses = StorageService.getReferenceType(
      "extendedModuleClasses",
    );
    const instanceTemplates = StorageService.getReferenceType(
      "instanceTemplates",
    );
    const networkProfiles = StorageService.getReferenceType("networkProfiles");
    const moduleClassesMap = StorageService.getReferenceType(
      "moduleClassesMap",
      "map",
    );

    if (
      examinations &&
      moduleClasses &&
      moduleClassesMap &&
      networkProfiles &&
      instanceTemplates
    ) {
      this.setState({
        instanceTemplates,
        networkProfiles,
        moduleClasses,
        examinations,
        moduleClassesMap,
      });
    }
    await this.fetchData();

    const instanceTemplateId = CamplaCoreService.getUrlParameter("create");
    if (instanceTemplateId) {
      this.resolveInstanceTemplate(instanceTemplateId);
      this.setState({
        selectedCloneExamination: null,
        showCreateExaminationModal: true,
      });
    }

    this.registerEventListener();
  }

  componentWillUnmount() {
    CamplaCoreService.removeEventListener("Examinations");
  }

  async handleCreateMultipleExaminations(
    examinationsToCreate,
    clonedExamination = null,
  ) {
    for (const moduleClassId of examinationsToCreate.moduleClasses) {
      const examination = Object.assign({}, examinationsToCreate);
      examination["moduleClassId"] = moduleClassId;
      delete examination["moduleClasses"];
      const status = await this.handleCreateExamination(
        examination,
        clonedExamination,
      );
      if (!status) break;
    }
  }

  async handleCreateExamination(examToCreate, clonedExamination) {
    try {
      let createdExamination;
      const owner = Object.assign({}, examToCreate["owner"]);
      delete examToCreate["owner"];
      examToCreate["userId"] = owner._id;
      if (clonedExamination) {
        createdExamination = await CamplaCoreService.cloneExamination(
          clonedExamination._id,
          examToCreate,
        );
      } else {
        createdExamination = await CamplaCoreService.createExamination(examToCreate);
      }

      const userId = createdExamination.userId;
      const examinationId = createdExamination._id;
      for (const audId of examToCreate.auditors) {
        const data = {
          userId: userId,
          examinationId: examinationId,
          auditorId: audId._id,
        };
        await CamplaCoreService.createExaminationAuditor(data);
      }

      // Reset url parameters
      const instanceTemplateId = CamplaCoreService.getUrlParameter("create");
      if (instanceTemplateId) CamplaCoreService.stripeUrlParameters();

      const updateState = await CamplaCoreService.getExtendedExaminations();
      this.setState({
        ...updateState,
        showCreateExaminationModal: false,
        dialogApiError: "",
      });
      return true;
    } catch (err) {
      this.setState({
        dialogApiError: APIErrorHelper.getError(
          err,
          () => this.setState({ dialogApiError: "" }),
          {
            PRECONDITION_FAILED: "Examinations.APIError.PreconditionFailed",
            NOT_FOUND: "Examinations.APIError.NotFound",
            BAD_REQUEST: "Examinations.APIError.BadRequestCreate",
            CONFLICT: "Examinations.APIError.Conflict",
          },
          this.props.t,
        ),
      });
    }
    return false;
  }

  async fetchData() {
    this.setState(await CamplaCoreService.getExtendedExaminations());
    const authenticatedUser = CamplaCoreService.getAuthenticatedUser();
    if (authenticatedUser && authenticatedUser.role === 1) {
      try {
        const allUsers = await CamplaCoreService.getAllUsers();
        const users = allUsers.filter(u => u.role === 1 || u.role === 0);
        this.setState({ users });
      } catch (err) {
        this.setState({
          dialogApiError: APIErrorHelper.getError(
            err,
            () => this.setState({ dialogApiError: "" }),
            {},
            this.props.t,
          ),
        });
      }
    }
  }

  async handleOpen(exam) {
    const { t } = this.props;
    this.setState({ openExam: true });

    try {
      const studentFileProposals = await CamplaCoreService.getAllStudentFilesByExamination(
        exam._id,
      );
      this.setState({ studentFileProposals });
    } catch (err) {
      this.setState({
        dialogApiError: APIErrorHelper.getError(
          err,
          () => this.setState({ dialogApiError: "" }),
          {
            PRECONDITION_FAILED: "Examinations.APIError.PreconditionFailed",
            NOT_FOUND: "Examinations.APIError.NotFound",
            BAD_REQUEST: "Examinations.APIError.BadRequest",
          },
          t,
        ),
      });
    }

    this.setActionConfirmationStateOpenExam(
      exam,
      t("Examinations.ConfirmationDialog.Open.Title"),
      t("Examinations.ConfirmationDialog.Open.Body", { examName: exam.name }),
      async () => {
        try {
          await CamplaCoreService.openExamination(
            this.state.examinationToDeleteOrEdit._id,
          );
          this.setState({
            dialogApiError: "",
            openExam: false,
            studentFileProposals: [],
          });
        } catch (err) {
          this.setState({
            dialogApiError: APIErrorHelper.getError(
              err,
              () => this.setState({ dialogApiError: "" }),
              {
                PRECONDITION_FAILED: "Examinations.APIError.PreconditionFailed",
                NOT_FOUND: "Examinations.APIError.NotFound",
                BAD_REQUEST: "Examinations.APIError.BadRequest",
              },
              t,
            ),
          });
        }
      },
      "green",
    );
  }

  handleClose(exam) {
    const { t } = this.props;

    this.setActionConfirmationState(
      exam,
      t("Examinations.ConfirmationDialog.Close.Title"),
      t("Examinations.ConfirmationDialog.Close.Body", { examName: exam.name }),
      async () => {
        try {
          await CamplaCoreService.closeExamination(
            this.state.examinationToDeleteOrEdit._id,
          );
          this.setState({
            dialogApiError: "",
            showConfirmationDialog: false,
          });
        } catch (err) {
          this.setState({
            dialogApiError: APIErrorHelper.getError(
              err,
              () => this.setState({ dialogApiError: "" }),
              {
                PRECONDITION_FAILED: "Examinations.APIError.PreconditionFailed",
                NOT_FOUND: "Examinations.APIError.NotFound",
                BAD_REQUEST: "Examinations.APIError.BadRequest",
              },
              t,
            ),
          });
        }
      },
      "red",
    );
  }

  handlePause(exam) {
    const { t } = this.props;

    this.setActionConfirmationState(
      exam,
      t("Examinations.ConfirmationDialog.Pause.Title"),
      t("Examinations.ConfirmationDialog.Pause.Body", { examName: exam.name }),
      async () => {
        try {
          await CamplaCoreService.pauseExamination(
            this.state.examinationToDeleteOrEdit._id,
          );
          this.setState({
            dialogApiError: "",
            showConfirmationDialog: false,
          });
        } catch (err) {
          this.setState({
            dialogApiError: APIErrorHelper.getError(
              err,
              () => this.setState({ dialogApiError: "" }),
              {
                PRECONDITION_FAILED: "Examinations.APIError.PreconditionFailed",
                NOT_FOUND: "Examinations.APIError.NotFound",
                BAD_REQUEST: "Examinations.APIError.BadRequest",
              },
              t,
            ),
          });
        }
      },
      "green",
    );
  }

  handleResume(exam) {
    const { t } = this.props;

    this.setActionConfirmationState(
      exam,
      t("Examinations.ConfirmationDialog.Resume.Title"),
      t("Examinations.ConfirmationDialog.Resume.Body", { examName: exam.name }),
      async () => {
        try {
          await CamplaCoreService.resumeExamination(
            this.state.examinationToDeleteOrEdit._id,
          );
          this.setState({
            dialogApiError: "",
            showConfirmationDialog: false,
          });
        } catch (err) {
          this.setState({
            dialogApiError: APIErrorHelper.getError(
              err,
              () => this.setState({ dialogApiError: "" }),
              {
                PRECONDITION_FAILED: "Examinations.APIError.PreconditionFailed",
                NOT_FOUND: "Examinations.APIError.NotFound",
                BAD_REQUEST: "Examinations.APIError.BadRequest",
              },
              t,
            ),
          });
        }
      },
      "green",
    );
  }

  async handleRetry(exam) {
    try {
      await CamplaCoreService.RetryExaminationAction(exam._id);
    } catch (err) {
      this.setState({
        apiError: APIErrorHelper.getError(
          err,
          () => this.setState({ apiError: "" }),
          {
            PRECONDITION_FAILED: "Examinations.APIError.PreconditionFailed",
            NOT_FOUND: "Examinations.APIError.NotFound",
            BAD_REQUEST: "Examinations.APIError.BadRequest",
          },
          this.props.t,
        ),
      });
    }
  }

  async handleClone(exam) {
    this.resolveInstanceTemplate(exam.instanceTemplateId);
    const auditors = await CamplaCoreService.getExaminationAuditors(exam._id);

    // renamed key "user" to "email" since Typeahead compenent expects email and all other API-Calls return "email", not "user"
    const auditorsRenamed = auditors.map((aud) => {
      const { user, auditorId, ...rest } = aud;
      return {
        _id: auditorId,
        email: user,
      };
    });
    exam["auditors"] = auditorsRenamed;

    this.setState({
      selectedCloneExamination: exam,
      showCreateExaminationModal: true,
    });
  }

  handleDelete(exam) {
    const { t } = this.props;

    this.setActionConfirmationState(
      exam,
      t("Examinations.ConfirmationDialog.Delete.Title"),
      t("Examinations.ConfirmationDialog.Delete.Body", { examName: exam.name }),
      async () => {
        try {
          await CamplaCoreService.deleteExamination(
            this.state.examinationToDeleteOrEdit._id,
          );
          this.setState({
            dialogApiError: "",
            showConfirmationDialog: false,
          });
        } catch (err) {
          this.setState({
            dialogApiError: APIErrorHelper.getError(
              err,
              () => this.setState({ dialogApiError: "" }),
              {
                PRECONDITION_FAILED: "Examinations.APIError.PreconditionFailed",
                NOT_FOUND: "Examinations.APIError.NotFound",
                BAD_REQUEST: "Examinations.APIError.BadRequest",
              },
              t,
            ),
          });
        }
      },
      "red",
    );
  }

  onHideCreateDialog(isFormDirty) {
    if (isFormDirty) {
      this.setState({
        showUnsavedChangesDialog: true,
        closeAction: () =>
          this.setState({
            showCreateExaminationModal: false,
          }),
      });
    } else {
      this.setState({
        showCreateExaminationModal: false,
      });
    }
  }

  setActionConfirmationState(
    exam,
    title,
    body,
    submitFunction,
    submitButtonVariant,
  ) {
    this.setState({
      showConfirmationDialog: true,
      examinationToDeleteOrEdit: exam,
      confirmationDialogTitle: title,
      confirmationDialogBody: body,
      onConfirmationDialogSubmit: submitFunction,
      confirmationDialogRightButtonVariant: submitButtonVariant,
      confirmationDialogLeftButtonVariant: "black",
    });
  }

  setActionConfirmationStateOpenExam(
    exam,
    title,
    body,
    submitFunction,
    submitButtonVariant,
  ) {
    this.setState({
      showConfirmationDialog: false,
      examinationToDeleteOrEdit: exam,
      confirmationDialogTitle: title,
      confirmationDialogBody: body,
      onConfirmationDialogSubmit: submitFunction,
      confirmationDialogRightButtonVariant: submitButtonVariant,
      confirmationDialogLeftButtonVariant: "black",
    });
  }

  async handleAcceptProposal(studentFileId) {
    const { t } = this.props;
    try {
      await CamplaCoreService.acceptStudentFile(studentFileId);
      const proposal = this.state.studentFileProposals.filter(
        (p) => p._id === studentFileId,
      )[0];
      const index = this.state.studentFileProposals.indexOf(proposal);
      const updatedStudentFileProposal = Object.assign(
        {},
        this.state.studentFileProposals[index],
      );
      updatedStudentFileProposal["isAccepted"] = true;
      const studentFileProposals = [...this.state.studentFileProposals];
      studentFileProposals[index] = updatedStudentFileProposal;
      this.setState({ studentFileProposals });
      return true;
    } catch (err) {
      this.setState({
        dialogApiError: APIErrorHelper.getError(
          err,
          () => this.setState({ dialogApiError: "" }),
          {
            PRECONDITION_FAILED:
              "SingleExamination.StudentFileProposalsTab.APIError.PreconditionFailed",
            NOT_FOUND: "",
            SERVER_ERROR: "",
          },
          t,
        ),
      });
    }
    return false;
  }

  render() {
    const timestamp = Date.now();
    const { t } = this.props;
    const columns = [
      {
        dataField: "name",
        text: t("Examinations.ColumnName"),
        sort: true,
        filter: textFilter({
          placeholder: t("Examinations.FilterNamePlaceholder"),
          style: { display: this.state.displayFilter },
        }),
        formatter: (name, examination) =>
          examination.status !== 0 &&
          examination.status !== 2 &&
          examination.status !== 3 ? (
            <Link
              className="item-link"
              to={{
                pathname: `/examinations/${examination._id}`,
                state: {
                  examination: examination,
                },
              }}
            >
              {name}
            </Link>
          ) : (
            <span>{name}</span>
          ),
      },
      {
        dataField: "moduleName",
        text: t("Examinations.ColumnModuleName"),
        sort: true,
        filter: textFilter({
          placeholder: t("Examinations.FilterModuleNamePlaceholder"),
          style: { display: this.state.displayFilter },
        }),
      },
      {
        dataField: "className",
        text: t("Examinations.ColumnClassName"),
        sort: true,
        filter: textFilter({
          placeholder: t("Examinations.FilterClassNamePlaceholder"),
          style: { display: this.state.displayFilter },
        }),
      },
      {
        dataField: "status",
        text: t("Examinations.ColumnStatus"),
        sort: true,
        filter: selectFilter({
          placeholder: t("Examinations.FilterStatusPlaceholder"),
          options: ExaminationStatus.getStatus().map((s) => ({
            value: s.code,
            label: t(s.translation),
          })),
          style: { display: this.state.displayFilter },
        }),
        formatter: (cell) => {
          return <ExaminationStatusCell code={cell} />;
        },
      },
      {
        dataField: "start",
        text: t("Examinations.ColumnStart"),
        sort: true,
        filter: dateFilter({
          style: { display: this.state.displayFilter },
          defaultValue: { date: undefined, comparator: Comparator.EQ },
        }),
        formatter: (start, examination) => (
          <span>
            {DateTimeHelper.formatDate(start)}{" "}
            {examination.isAutoStart ? (
              <span className="fa-layers fa-fw" title="Autostart">
                <FontAwesomeIcon
                  icon={faPlay}
                  className="color-green"
                  style={{ fontSize: "5pt", paddingLeft: "2px" }}
                />
                <FontAwesomeIcon
                  icon={faSyncAlt}
                  style={{ fontSize: "12pt" }}
                />
              </span>
            ) : (
              ""
            )}
          </span>
        ),
      },
      {
        dataField: "instancesCount",
        text: "",
        headerStyle: () => {
          return { width: "60px" };
        },
        headerFormatter: () => <FontAwesomeIcon icon={faUsers} />,
        sort: true,
      },
      {
        dataField: "user",
        text: t("Examinations.ColumnOwner"),
        sort: true,
        filter: textFilter({
          placeholder: t("Examinations.FilterOwnerPlaceholder"),
          style: { display: this.state.displayFilter },
        }),
      },
      {
        dataField: "actions",
        text: "",
        headerFormatter: () => (
          <PaginationTableFilterToggle
            onFilterToggle={(e) => {
              this.setState({
                showFilters: e.currentTarget.checked,
                displayFilter: e.currentTarget.checked ? "initial" : "none",
              });
            }}
            showFilters={this.state.showFilters}
            tableId={this.tableId}
          />
        ),
        headerClasses: "actionHeader",
        isDummyField: true,
        csvExport: false,
        formatter: (_, exam) => (
          <ExaminationActionCell
            onDelete={() => this.handleDelete(exam)}
            onOpen={() => this.handleOpen(exam)}
            onClose={() => this.handleClose(exam)}
            onPause={() => this.handlePause(exam)}
            onResume={() => this.handleResume(exam)}
            onRetry={() => this.handleRetry(exam)}
            onClone={() => this.handleClone(exam)}
            exam={exam}
          />
        ),
      },
    ];

    return (
      <div>
        <CreateExaminationDialog
          show={this.state.showCreateExaminationModal}
          moduleClasses={this.state.moduleClasses}
          instanceTemplates={this.state.instanceTemplates}
          networkProfiles={this.state.networkProfiles}
          users={this.state.users}
          selectedInstanceTemplate={this.state.selectedInstanceTemplate}
          cloneExamination={this.state.selectedCloneExamination}
          onHide={this.onHideCreateDialog}
          dialogApiError={this.state.dialogApiError}
          onSubmit={this.handleCreateMultipleExaminations}
        />

        <OpenExamAndAcceptSubmissionsDialog
          open={true}
          studentFileProposals={this.state.studentFileProposals}
          title={this.state.confirmationDialogTitle}
          body={this.state.confirmationDialogBody}
          show={this.state.openExam}
          dialogApiError={this.state.dialogApiError}
          onHide={() =>
            this.setState({
              openExam: false,
              studentFileProposals: [],
            })
          }
          onSubmit={this.state.onConfirmationDialogSubmit}
          confirmButtonVariant={this.state.confirmationDialogRightButtonVariant}
          cancelButtonVariant={this.state.confirmationDialogLeftButtonVariant}
          rightButtonText={t("SingleExamination.ConfirmationDialog.Confirm")}
          onAcceptProposal={async (studentFileId) =>
            this.handleAcceptProposal(studentFileId)
          }
        />

        <UnsavedChangesDialog
          show={this.state.showUnsavedChangesDialog}
          onHide={() => this.setState({ showUnsavedChangesDialog: false })}
          onSubmit={() => {
            this.setState({ showUnsavedChangesDialog: false });
            this.state.closeAction();
          }}
        />

        <ConfirmationDialog
          title={this.state.confirmationDialogTitle}
          body={this.state.confirmationDialogBody}
          show={this.state.showConfirmationDialog}
          dialogApiError={this.state.dialogApiError}
          onHide={() =>
            this.setState({
              showConfirmationDialog: false,
            })
          }
          onSubmit={this.state.onConfirmationDialogSubmit}
          confirmButtonVariant={this.state.confirmationDialogRightButtonVariant}
          cancelButtonVariant={this.state.confirmationDialogLeftButtonVariant}
          confirmButtonText={t("Examinations.ConfirmationDialog.Confirm")}
        />

        <Container className="mt-3">
          <Row className="pageTitle">
            <Col>
              <h2>{t("Examinations.Title")}</h2>
            </Col>
            <Col>
              <Button
                className="footer-action-button btn-green"
                style={{ float: "right" }}
                onClick={() => (window.location.href = "/templateMarketplace")}
              >
                <FontAwesomeIcon icon={faPlus} />
              </Button>
            </Col>
          </Row>
          {this.state.apiError ? (
            <Row>
              <Col>{this.state.apiError}</Col>
            </Row>
          ) : (
            ""
          )}
          <Row>
            <Col>
              <PaginationTable
                key={timestamp}
                data={this.state.examinations} /* {newState} */
                sizePerPage={50}
                paginationSize={3}
                columns={columns}
                keyField="_id"
                ref={this.paginationTableRef}
                id={this.tableId}
                noDataFoundLabel={t("Examinations.NoExaminationsFound")}
                view="examinations"
              />
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default withTranslation()(withRouter(Examinations));
